<template>
    <div class="dd-m-card dd-m-card--slider-default dd-m-card--slider-default--shadow" v-if="item">
        <picture class="dd-m-card--slider-default__bg">
            <source :srcset="item.image.desktop" media="(min-width: 1280px)">
            <source :srcset="item.image.tablet" media="(min-width: 768px)">
            <img :srcset="item.image.mobile" :alt="item.title">
        </picture>

        <div class="dd-m-card--slider-default__content">
            <h3 class="dd-m-card--slider-default__title">{{item.title}}</h3>
            <h4 class="dd-m-card--slider-default__subtitle">{{item.description}}</h4>

            <a class="dd-m-button dd-m-button--assertive dd-m-button--auto"
               :target="item.target === 1 ? '_self' : '_blank'"
               :title="item.title"
               :href="lang + item.link">
                {{item.textbutton}}
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'card',
        props: ['item'],
        data: () => {
            return {
                lang: ''
            }
        },
        mounted() {
            this.lang = language !== 'en' ? '/' + language : '';
        },
        methods: {
            getLink(link) {
                if (link.indexOf('http') !== -1) {
                    return link;
                } else {
                    return (this.lang + '/' + link).replace('//', '/');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/cards/card.vue